import Container from 'react-bootstrap/Container'
import ButtonCinestar from '../../Buttons/ButtonCinestar/ButtonCinestar'
import Typography from '../../Typography/Typography'
import './ErrorWindow.scss'

const ErrorWindow = ({ title, description, textButton1, onClickButton1, textButton2, onClickButton2 }) => {
    return (
        <Container fluid className={'error-window d-flex justify-content-between text-formPrimary'}>
            <div className={'error-window--info d-flex flex-column'}>
                <Typography variant={'h2'}>{title}</Typography>
                <Typography variant={'p'}>{description}</Typography>
                <div className={'error-window--buttons d-flex'}>
                    <ButtonCinestar variant={'primary-v1'} onClick={onClickButton1}>
                        {textButton1}
                    </ButtonCinestar>
                    {textButton2 && (
                        <ButtonCinestar variant={'secondary'} onClick={onClickButton2} iconLeft={'cross'}>
                            {textButton2}
                        </ButtonCinestar>
                    )}
                </div>
            </div>
            <img src={'images/badges/error.svg'} alt={'error'} className={'error-img my-auto'} />
        </Container>
    )
}

export default ErrorWindow
